module.exports = __webpack_public_path__ + "img/xqxh8.6df18f37.png";